angular
  .module('vppApp')
  .directive('compileJsonElementDirective', compileJsonElementDirective);

  compileJsonElementDirective.$inject = ['$rootScope', '$compile', '$timeout'];

  function compileJsonElementDirective ($rootScope, $compile, $timeout) {
    return {
      replace: true,
      link: function(scope, element, attrs) {

        $rootScope.$on("$stateChangeSuccess", function(event, toState, toParams, fromState, fromParams) {
          compileStaticValue();
        });

        scope.$on('fireCompileJsonElementDirective', function (event, data) {
          compileStaticValue();
        });

        var compileStaticValue = function (){
          $timeout(function(){
            var templateHtml = angular.element(element);
            var finalTemplateHtml = $compile(templateHtml[0].innerHTML)($rootScope);
            templateHtml[0].innerHTML = finalTemplateHtml[0].outerHTML;
          });
        }

        compileStaticValue();

      }

    }

  };